<script>
export default {
    name: "UnpostedBillsPrint",

    data() {

        return {
            patients: [],
        };
    },

    computed: {

        totalUnpostedBills() {

            if(!this.patients.length) return 0;

            return this.patients.map(patient => patient.amount ? parseFloat(patient.amount) : 0)
                .reduce((sum, amt) => sum + amt);
        },
    },

    mounted() {

        Promise.allSettled([ this.fetchUnpostedBills(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchUnpostedBills() {

            let url = `AccountsReports/GetUnPostedBillsReport?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
            url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;
            url += this.$route.query.user ? `&User=${this.$route.query.user}` : ``;

            return this.$http.get(url).then(response => {
                this.patients = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full text-center my-2">
            <h5 class="font-medium">Unposted patient bills</h5>
        </div>
        <table class="table table-striped">
            <thead class="text-sm">
                  <tr class="w-full flex">
                      <th class="p-tiny w-1/6">MRN</th>
                      <th class="p-tiny w-1/6">PATIENT</th>
                      <th class="p-tiny w-1/6">IP NO</th>
                      <th class="p-tiny w-1/6">OP NO</th>
                      <th class="p-tiny w-1/6">Username</th>
                      <th class="p-tiny w-1/6">Amount</th>
                  </tr>
            </thead>
            <tfoot>
                <tr class="w-full flex font-medium text-base">
                    <td class="p-tiny w-1/2"></td>
                    <td class="p-tiny w-1/2 text-right">Total: {{ totalUnpostedBills | numberFormat }}</td>
                </tr>
            </tfoot>
            <tbody class="text-xs flex flex-col items-center">
                <tr class="w-full flex" v-for="(patient, idx) in patients" :key="idx">
                    <td class="p-tiny w-1/6">{{ patient.patientID }}</td>
                    <td class="p-tiny w-1/6">{{ patient.names }}</td>
                    <td class="p-tiny w-1/6">{{ patient.ipfileno }}</td>
                    <td class="p-tiny w-1/6">{{ patient.opfileno }}</td>
                    <td class="p-tiny w-1/6">{{ patient.userName }}</td>
                    <td class="p-tiny w-1/6">{{ patient.amount | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>